<template>
  <section>
    <div class="overlay"></div>
      <section class="page-home">
        <div class="page__header text-center">
            <h5 class="page__header--text">Hello!</h5>
            <h4 class="page__header--text">Where do you want to go?</h4>
        </div>
        <div class="search__section px-4">
            <div class="search__section--wrapper">
                <div class="input__section d-flex justify-content-center text-white">
                    <div class="text-center">
                        <input @change="resetForm" type="radio" value="Return" v-model="form.flightSearchType" name="tripType" class="mr-1" checked>
                        <label for="roundtrip">Round Trip</label>
                    </div>
                    <div class="ml-3 text-center">
                        <input type="radio" @change="resetForm"  value="Oneway" v-model="form.flightSearchType" name="tripType" class="mr-1">
                        <label for="oneway">One-Way</label>
                    </div>
                    <div class="ml-3 text-center">
                        <input type="radio" @change="resetForm"  value="Multidestination" v-model="form.flightSearchType" name="tripType" class="mr-1">
                        <label for="multiway">Multi-Way</label>
                    </div>
                </div>
                <!-- one way form  -->
                <section v-if="form.flightSearchType !== 'Multidestination'" class="form-section flight-form-wrapper mt-4">
                    <div class="flight-from d-flex py-2 px-3">
                        <div class="mt-3">
                            <img src="@/assets/TAJimages/flight/Icon material-flight-takeoff.png" alt="take-off">
                        </div>
                        <div class="ml-3 flight-text">
                            <h6 class="ml-2">From</h6>
                            <h6 v-if="isFlightLoading" class="ml-2 mt-1 text-danger">Please wait...</h6>
                            <div v-else class="search-wrapper" @click="toggleDropDown('departure')">
                                <input type="text" v-model="searchDeparture" class="search-form" placeholder="Search Departure"/>
                            </div>
                            <!-- <v-select v-else :searchable="false" label="airportName" v-model="itineraries.departure" placeholder="Select Departure" :options="allAirports" :reduce="airportName => airportName.airportName"></v-select> -->
                        </div>
                        <div class="airport-wraper animated fadeIn" v-if="isDepatureDropdown">
                          <p v-if="isPortLoading" class="ml-2 mt-1 text-center text-danger">Please wait...</p>
                            <div v-else v-for="airport in allAirports" :key="airport.airportName" @click="setValue(airport, 'departure')">
                                <p class="my-2" style="font-size:16px">{{ airport.airportName }} {{ airport.cityCountry}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="refresh">
                        <img src="@/assets/TAJimages/flight/refresh.png" alt="refresh">
                    </div>
                    <div class="flight-from d-flex ml-3 py-2 px-3">
                        <div class="mt-3">
                            <img src="@/assets/TAJimages/flight/Icon material-flight-land.png" alt="take-down">
                        </div>
                        <div class="ml-3 flight-text">
                            <h6 class="ml-2">To</h6>
                            <h6 v-if="isFlightLoading" class="ml-2 mt-1 text-danger">Please wait...</h6>
                            <div v-else class="search-wrapper" @click="toggleDropDown('destination')">
                                <input type="text" v-model="searchDestination" class="search-form" placeholder="Search Destination"/>
                            </div>
                            <!-- <v-select v-else label="airportName" v-model="itineraries.destination" placeholder="Select Destination" :options="allAirports" :reduce="airportName => airportName.airportName"></v-select> -->
                        </div>
                        <div class="airport-wraper-destination animated fadeIn" v-if="isDestinationDropdown">
                          <p v-if="isDesLoading" class="ml-2 mt-1 text-center text-danger">Please wait...</p>
                          <div v-else v-for="airport in allAirports" :key="airport.airportName" @click="setValue(airport, 'destination')">
                            <p class="my-2" style="font-size:16px">{{ airport.airportName }} {{ airport.cityCountry}}</p>
                          </div>
                        </div>
                    </div>
                    <section class="d-flex m-h-4">
                      <div class="button__section d-flex align-items-center ml-2" @click="showDateModal">
                        <div class="flight-date p-3">
                            <section :class="form.flightSearchType === 'Oneway' ? 'justify-content-center' : 'justify-content-between'" class="d-flex" v-if="form.itineraries.length >= 1">
                                <div class="text-center">
                                    <h6 class="text-class mb-1" style="font-size:10px">Departure</h6>
                                    <h6 class="text-eco" style="font-size:12px; width:60px">{{ viewDate.departureDate }}</h6>
                                    <!-- <h6 class="text-cabin">Nov</h6> -->
                                </div>
                                <div class="text-center" v-if="form.flightSearchType !== 'Oneway'">
                                    <h6 class="text-class mb-1" style="font-size:10px">Return On</h6>
                                    <h6 class="text-eco pb-1" style="font-size:12px; width:60px">{{viewDate.returnDate }}</h6>
                                    <!-- <h6 class="text-cabin">Nov</h6>  -->
                                </div>
                            </section>
                            
                           <div v-if="form.itineraries.length < 1">
                               Dates <span class="ml-3"><img src="@/assets/TAJimages/flight/flight-date.png" alt="date"></span>
                            </div>  
                        </div>
                      </div>
                      <div class="d-flex align-items-center justify-content-between py-4 flight-type" @click="openFlightDetails">
                          <div style="position: relative;">
                              <h6 class="text-cabin">Cabin</h6>
                              <h6 class="text-eco">{{ form.ticketclass == 'Y' ? 'ECO' : form.ticketclass == 'C' ? 'BIS' : form.ticketclass == 'W' ? 'P-ECO' : 'FC' }}</h6>
                              <h6 class="text-class">Class</h6>
                              <h6 class="text-number">{{ form.children + form.adults + form.infants}}</h6>
                          </div>
                          <div>
                              <img src="@/assets/TAJimages/flight/Icon ionic-md-man.png" alt="man">
                          </div>
                      </div>
                    </section>
                    
                    <section v-if="isDateOpen" class="animated fadeIn date-wrapper my-4">
                        <div class="pb-3 text-right">
                            <button type="button" class="btn btn-danger" @click="closeDateModal('one-way')">Ok</button>
                        </div>
                        <div class="d-flex" :class="form.flightSearchType === 'Oneway' ? 'justify-content-center':'justify-content-between'">
                            <div>
                                <p class="font-weight-bold">Choose your depature date</p>
                                <DatePicker color="red" @input="setDepartureDate($event, 'depature')" :min-date='new Date()'/>
                            </div>
                            <div v-if="form.flightSearchType !== 'Oneway'">
                                <p class="font-weight-bold text-right">Choose your Return date</p>
                                <DatePicker color="red" @input="setDepartureDate($event, 'return-date')" :disabled-dates="form.flightSearchType === 'Oneway'" :min-date='itineraries.departureDate'/>
                            </div>
                        </div>
                    </section>
                    <div v-if="isFlightType" class="animated fadeIn flight-type-menu">
                        <div class="menu--wrapper d-flex align-items-center justify-content-between flex-wrap">
                            <div class="select--menu">
                                <input type="radio" value="Y" v-model="form.ticketclass" name="flightType">
                                <label class="ml-2">Economy Class</label>
                            </div>
                            <div class="select--menu">
                                <input type="radio" value="C" v-model="form.ticketclass" name="flightType">
                                <label class="ml-2">Business Class</label>
                            </div>
                            <div class="select--menu mt-2">
                                <input type="radio" value="F" v-model="form.ticketclass" name="flightType">
                                <label class="ml-2">First Class</label>
                            </div>
                            <div class="select--menu mt-2">
                                <input type="radio" value="W" v-model="form.ticketclass" name="flightType">
                                <label class="ml-2">Premium Economy</label>
                            </div>
                        </div>
                        <div class="pass-section">
                            <h4>Passengers:</h4>
                            <div>
                                <div class="d-flex justify-content-between">
                                    <div class="pass-text">
                                        <h4>Adults</h4>
                                        <p>&#62; 12 yrs</p>
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <div class="minus" @click="form.adults > 0 ? form.adults-- : form.adults = 0">-</div>
                                        <span class="mx-3 font-weight-bold">{{form.adults}}</span>
                                        <div class="plus" @click="form.adults === 6 ? form.adults : form.adults++">+</div>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-between my-4">
                                    <div class="pass-text">
                                        <h4>Children </h4>
                                        <p>2 - 12 yrs</p>
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <div class="minus" @click="form.children > 0 ? form.children-- : form.children = 0">-</div>
                                        <span class="mx-3 font-weight-bold">{{form.children}}</span>
                                        <div class="plus" @click="form.children === 4 ? form.children : form.children++">+</div>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-between">
                                    <div class="pass-text">
                                        <h4>Infants</h4>
                                        <p> &#60; 2 yrs</p>
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <div class="minus" @click="form.infants > 0 ? form.infants-- : form.infants = 0">-</div>
                                        <span class="mx-3 font-weight-bold">{{ form.infants }}</span>
                                        <div class="plus" @click="increaseCount">+</div>
                                    </div>
                                </div>
                                <p class="text-danger pt-2" style="font-size: 12px">{{ infantText }}</p>
                            </div>
                        </div>
                        <div class="d-flex justify-content-center align-items-center mt-2">
                            <p class="text-danger mr-5 mt-3" style="cursor:pointer" @click="closeFlightDetails">Close</p>
                            <button type="button" class="btn btn-sm btn-danger" @click="setFlightDetails">Set</button>
                        </div>
                    </div>
                </section>
                <!-- Multidestination form  -->
                <section v-if="form.flightSearchType == 'Multidestination'">
                    <div class="form-section flight-form-wrapper mt-4" v-for="(multiForm, index) in flightForm" :key="index">
                        <div class="d-flex align-items-center justify-content-between py-4 mr-3 flight-type-multi" @click="openFlightDetails">
                            <h3>{{ index + 1}}</h3>
                        </div>
                        <div class="flight-from d-flex py-2 px-3">
                            <div class="mt-3">
                                <img src="@/assets/TAJimages/flight/Icon material-flight-takeoff.png" alt="take-off">
                            </div>
                            <div class="ml-3 flight-text">
                                <h6 class="ml-2">From</h6>
                                <h6 v-if="isFlightLoading" class="ml-2 mt-1 text-danger">Please wait...</h6>
                                <multiselect v-else id="ajax" v-model="multiForm.itineraries.departure" :show-labels="false" :options="allAirports" placeholder="Select Departure" :custom-label="airportFullDetails" label="airportName" track-by="airportName" :loading="isPortLoading" @search-change="getDeparturePort"></multiselect>
                            </div>
                        </div>
                        <div class="refresh multi-way">
                            <img src="@/assets/TAJimages/flight/refresh.png" alt="refresh">
                        </div>
                        <div class="flight-from d-flex ml-3 py-2 px-3">
                            <div class="mt-3">
                                <img src="@/assets/TAJimages/flight/Icon material-flight-land.png" alt="take-down">
                            </div>
                            <div class="ml-3 flight-text">
                                <h6 class="ml-2">To</h6>
                                <h6 v-if="isFlightLoading" class="ml-2 mt-1 text-danger">Please wait...</h6>
                                <multiselect v-else v-model="multiForm.itineraries.destination" :options="allAirports" placeholder="Select Destination" :custom-label="airportFullDetails" label="airportName" track-by="airportName" :show-labels="false" :loading="isDesLoading" @search-change="getDestinationPort"></multiselect>
                            </div>
                        </div>
                        <div class="button__section d-flex align-items-center ml-2" @click="[showDateModal(), setDateIndex(index)]">
                            <div class="flight-date p-3">
                                <section v-if="multiForm.itineraries.departureDate" :class="form.flightSearchType === 'Multidestination' ? 'justify-content-center' : 'justify-content-between'" class="d-flex">
                                    <div class="text-center">
                                        <h6 class="text-class mb-1" style="font-size:10px">Departure</h6>
                                        <h6 class="text-eco" style="font-size:12px; width:60px">{{multiForm.itineraries.departureDate | formatDate }}</h6>
                                        <!-- <h6 class="text-cabin">Nov</h6> -->
                                    </div>
                                </section>
                                <div v-else>
                                    Dates <span class="ml-3"><img src="@/assets/TAJimages/flight/flight-date.png" alt="date"></span>
                                </div> 
                            </div>
                        </div>
                        
                        <section v-if="isDateOpen" class="animated fadeIn date-wrapper my-4">
                            <div class="pb-3 text-right">
                                <button type="button" class="btn btn-danger" @click="closeDateModal('multi-way')">Ok</button>
                            </div>
                            <div class="d-flex" :class="form.flightSearchType === 'Multidestination' ? 'justify-content-center' : 'justify-content-center'">
                                <div>
                                    <p class="font-weight-bold">Choose your depature date</p>
                                    <DatePicker color="red" v-model="dateValue" :min-date='minimumDate' :max-date='maximumDate'/>
                                </div>
                                <div v-if="form.flightSearchType !== 'Multidestination'">
                                    <p class="font-weight-bold text-right">Choose your arrival date</p>
                                    <DatePicker color="red" v-model="itineraries.returnDate" :disabled-dates="form.flightSearchType === 'Multidestination'" :min-date='itineraries.departureDate'/>
                                </div>
                            </div>
                        </section>
                        <div v-if="isFlightType" class="animated fadeIn flight-type-menu mb-5">
                            <div class="menu--wrapper d-flex align-items-center justify-content-between flex-wrap">
                                <div class="select--menu">
                                    <input type="radio" value="Y" v-model="form.ticketclass" name="flightType">
                                    <label class="ml-2">Economy Class</label>
                                </div>
                                <div class="select--menu">
                                    <input type="radio" value="C" v-model="form.ticketclass" name="flightType">
                                    <label class="ml-2">Business Class</label>
                                </div>
                                <div class="select--menu mt-2">
                                    <input type="radio" value="F" v-model="form.ticketclass" name="flightType">
                                    <label class="ml-2">First Class</label>
                                </div>
                                <div class="select--menu mt-2">
                                    <input type="radio" value="W" v-model="form.ticketclass" name="flightType">
                                    <label class="ml-2">Premium Economy</label>
                                </div>
                            </div>
                            <div class="pass-section">
                                <h4>Passengers:</h4>
                                <div>
                                    <div class="d-flex justify-content-between">
                                        <div class="pass-text">
                                            <h4>Adults</h4>
                                            <p>&#62; 12 yrs</p>
                                        </div>
                                        <div class="d-flex align-items-center">
                                            <div class="minus" @click="form.adults > 0 ? form.adults-- : form.adults = 0">-</div>
                                            <span class="mx-3 font-weight-bold">{{form.adults}}</span>
                                            <div class="plus" @click="form.adults === 6 ? form.adults : form.adults++">+</div>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-between my-4">
                                        <div class="pass-text">
                                            <h4>Children </h4>
                                            <p>2 - 12 yrs</p>
                                        </div>
                                        <div class="d-flex align-items-center">
                                            <div class="minus" @click="form.children > 0 ? form.children-- : form.children = 0">-</div>
                                            <span class="mx-3 font-weight-bold">{{form.children}}</span>
                                            <div class="plus" @click="form.children === 4 ? form.children : form.children++">+</div>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-between">
                                        <div class="pass-text">
                                            <h4>Infants</h4>
                                            <p> &#60; 2 yrs</p>
                                        </div>
                                        <div class="d-flex align-items-center">
                                            <div class="minus" @click="form.infants > 0 ? form.infants-- : form.infants = 0">-</div>
                                            <span class="mx-3 font-weight-bold">{{ form.infants}}</span>
                                            <div class="plus" @click="increaseCount">+</div>
                                        </div>
                                    </div>
                                    <p class="text-danger pt-2" style="font-size: 12px">{{ infantText }}</p>
                                </div>
                            </div>
                            <div class="d-flex justify-content-center align-items-center mt-2">
                                <p class="text-danger mr-5 mt-3" style="cursor:pointer" @click="closeFlightDetails">Close</p>
                                <button type="button" class="btn btn-sm btn-danger" @click="setFlightDetails">Set</button>
                            </div>
                        </div>
                        <div @click="deleteFormRow" class="ml-4" style="cursor:pointer">
                            <img src="@/assets/TAJimages/close.png" alt="close">
                        </div>
                    </div>
                    <div class="mt-4 d-flex justify-content-between" style="margin: 0 50px">
                        <button type="button" class="btn btn-custom px-4 py-3" @click="addNewFlightForm">Add Flight</button>
                        <div class="d-flex align-items-center justify-content-between py-4 flight-type mr-5" @click="openFlightDetails">
                            <div style="position: relative;">
                                <h6 class="text-cabin">Cabin</h6>
                                <h6 class="text-eco">{{ form.ticketclass == 'Y' ? 'ECO' : form.ticketclass == 'C' ? 'BUS' : form.ticketclass == 'W' ? 'P-ECO' : 'FIR' }}</h6>
                                <h6 class="text-class">Class</h6>
                                <h6 class="text-number">{{ form.children + form.adults + form.infants}}</h6>
                            </div>
                            <div>
                                <img src="@/assets/TAJimages/flight/Icon ionic-md-man.png" alt="man">
                            </div>
                        </div>
                    </div>
                </section>
                <div class="text-center mt-5">
                    <button type="button" :disabled="isLoading" class="btn btn-danger search-btn" @click="searchFlight">
                        <div v-if="isLoading">Please wait...</div>
                        <div v-else>Search Flights</div>
                    </button>
                </div>
            </div>
        </div>
      </section>
    <div v-if="isLoading" class="loader-12"></div>
  </section>
</template>

<script>
  import { decrypt } from '@/_services/encryption';
  import Multiselect from 'vue-multiselect';
  import { mapState, mapActions } from 'vuex';
  import DatePicker from 'v-calendar/lib/components/date-picker.umd';
  import moment from 'moment';
  export default {
    components: {
      Multiselect,
      DatePicker
    },
    filters: {
      formatDate(date) {
        return moment(date).format('ddd DD, MMM');
      }
    },
    data:() => ({
      dateValue: new Date(),
      value: [],
      isSearch: true,
      searchDeparture: '',
      searchDestination: '',
      isFlightType: false,
      isDateOpen: false,
      isFlightLoading: false,
      isLoading: false,
      isDepatureDropdown: false,
      isDestinationDropdown: false,
      flightForm: [],
      form: {
        flightSearchType: 'Return',
        ticketclass: 'Y',
        adults: 0,
        children: 0,
        infants: 0,
        itineraries: [],
        targetCurrency: 'NGN',
        appPlatform: 1,
      },
      itineraries: {
        departure: '',
        destination: '',
        departureDate: '',
      },
      returnDepartureDate: '',
      dateIndex: '',
      viewDate: {
        departureDate: '',
        returnDate: ''
      },
      infantText: '',
      isPortLoading: false,
      isDesLoading: false,
      minimumDate: '',
      maximumDate: ''
    }),
    watch: {
      'form.infants' () {
        if(this.form.infants === this.form.adults) {
          this.infantText = 'Each Adults can only accompany the max of 1 infant'
        } else {
          this.infantText = ''
        }
      },
      'form.adults' () {
        if(this.form.infants > this.form.adults) {
          this.form.infants = this.form.adults
        }
      },
      dateValue () {
        if (this.dateValue === null) {
          this.dateValue = this.flightForm[this.dateIndex].itineraries.departureDate
        }
      },
      async searchDeparture (newVal, oldVal) {
        this.isPortLoading = true
        await this.getAllAirports(newVal)
        this.isPortLoading = false
      },
      async searchDestination (newVal, oldVal) {
        this.isDesLoading = true
        await this.getAllAirports(newVal)
        this.isDesLoading = false
      },
      dateIndex () {
        switch (this.dateIndex) {
          case 0:
            this.minimumDate =  new Date()
            this.dateValue = this.flightForm[0].itineraries.departureDate
            break;
          case 1:
            this.minimumDate = this.flightForm[0].itineraries.departureDate
            this.dateValue = this.flightForm[1].itineraries.departureDate
            break;
          case 2:
            this.minimumDate = this.flightForm[1].itineraries.departureDate
            this.dateValue = this.flightForm[2].itineraries.departureDate
            break;
          case 3:
            this.minimumDate = this.flightForm[2].itineraries.departureDate
            this.dateValue = this.flightForm[3].itineraries.departureDate
            break;
          case 4:
            this.minimumDate = this.flightForm[3].itineraries.departureDate
            this.dateValue = this.flightForm[4].itineraries.departureDate
            break;
          case 5:
            this.minimumDate = this.flightForm[4].itineraries.departureDate
            this.dateValue = this.flightForm[5].itineraries.departureDate
            break;
          default:
            break;
        }
      },
    },
    computed:{
      ...mapState('flight', ['allAirports', 'listOfFlights'])
    },
    async mounted() {
      this.flightForm.push({
        itineraries: {
          departure: '',
          destination: '',
          departureDate: new Date()
        },
      });
      this.isFlightLoading = true;
      try {
        await this.getAllAirports();
        this.isFlightLoading = false;
      } catch(error) {
        this.isFlightLoading = false;
        const decryptedError = decrypt(error.response.data);
        const objError = JSON.parse(decryptedError);
        this.$swal({
          title: 'Oops...',
          text: objError.errors[0],
          type: 'error',
          confirmButtonText: 'Ok'
        });
      }
    },
    methods: {
      ...mapActions('flight', ['getAllAirports', 'getListOfFlights']),
      increaseCount () {
        if (this.form.infants < 4 && (this.form.infants < this.form.adults)) {
          this.form.infants++
        }
      },
      airportFullDetails ({ airportName, cityCountry }) {
        return `${airportName} ${cityCountry}`
      },
      async getDeparturePort (query) {
        this.isPortLoading = true
        await this.getAllAirports(query)
        this.isPortLoading = false
      },
      async getDestinationPort (query) {
        this.isDesLoading = true
        await this.getAllAirports(query)
        this.isDesLoading = false
      },
      setDepartureDate (date, type) {
        switch (type) {
          case 'depature':
          this.itineraries.departureDate = date
            if (date === null) {
              this.viewDate.departureDate = 'Select Date'
            } else {
              this.viewDate.departureDate = moment(date).format('ddd DD, MMM')
            }
            break;
          case 'return-date':
            this.returnDepartureDate = date
          if (date === null) {
              this.viewDate.returnDate = 'Select Date'
            } else {
              this.viewDate.returnDate = moment(date).format('ddd DD, MMM')
            }
          default:
            break;
        }
      },
      setDateValue(value) {
        this.flightForm.forEach((item, index) => {
          if (value === index) {
            this.flightForm[value].itineraries.departureDate = this.dateValue
          }
        })
        switch (value) {
          case 0:
            this.flightForm[1].itineraries.departureDate = ''
            break;
          case 1:
            this.flightForm[2].itineraries.departureDate = ''
            break;
          case 2:
            this.flightForm[3].itineraries.departureDate = ''
            break;
          case 3:
            this.flightForm[4].itineraries.departureDate = ''
            break;
          case 4:
            this.flightForm[5].itineraries.departureDate = ''
            break;
          default:
            break;
        }
        // this.flightForm[value + 1].itineraries.departureDate = this.dateValue
      },
      setDateIndex(index) {
        this.dateIndex = index
      },
      addNewFlightForm() {
        if(this.isDateOpen) {
          this.isDateOpen = false
        }
        if (this.flightForm.length <= 5) {
          var day = new Date(this.dateValue);
          var nextDay = new Date(day);
          nextDay.setDate(day.getDate() + 1);
          this.flightForm.push({
            itineraries: {
              departure: '',
              destination: '',
              departureDate: ''
            },
          });
        } else {
          this.$swal({
            title: 'Oops...',
            text: 'Multi-way itinerary cannot be more than 6',
            type: 'error',
            confirmButtonText: 'Ok',
          });
        }
      },
      setValue(value, item) {
        if (item === 'departure') {
          this.itineraries.departure = value.airportCode;
          this.searchDeparture = value.airportName;
          this.isDepatureDropdown = false;
        } else if (item === 'destination') {
          this.itineraries.destination = value.airportCode;
          this.searchDestination = value.airportName;
          this.isDestinationDropdown = false;
        }
      },
      toggleDropDown(type) {
        if(type === 'departure') {
          this.isDepatureDropdown = !this.isDepatureDropdown;
          this.isDestinationDropdown = false;
        } else if(type === 'destination') {
          this.isDestinationDropdown = !this.isDestinationDropdown;
          this.isDepatureDropdown = false;
        }
      },
      deleteFormRow(index) {
        if (this.flightForm.length > 1) {
          this.flightForm.splice(index, 1);
        }
      },
      async callSerachForMultiway() {
        const flightData = [];
        this.flightForm.forEach((flight) => {
          flight.itineraries.departureDate = moment(flight.itineraries.departureDate).format('YYYY-MM-DD');
          flightData.push(flight.itineraries);
        });
        const newData = flightData.map((data) => {
          return {
            departureDate: data.departureDate,
            departure: data.departure.airportCode,
            destination: data.destination.airportCode
          };
        });
        const data = {
          flightSearchType: this.form.flightSearchType,
          ticketclass: this.form.ticketclass,
          adults: this.form.adults,
          children: this.form.children,
          infants: this.form.infants,
          itineraries: newData,
          targetCurrency: this.form.targetCurrency,
          appPlatform: this.form.appPlatform,
        };
        this.isLoading = true;
        this.$store.dispatch('flight/getListOfFlights', data).then(() => {
          const index = this.flightForm.length
          this.$store.commit('flight/SET_MULTI_WAY_DATE', this.flightForm[index].itineraries.departureDate)
          this.$store.commit('flight/SET_FLIGHT_TYPE', this.form.flightSearchType)
          this.isLoading = false;
          if(this.listOfFlights.length > 0) {
            this.$router.push({ name: 'flight-search' });
          } else {
            this.$swal({
              title: 'Oops...',
              text: 'No flights found',
              type: 'error',
              confirmButtonText: 'Ok',
            });
          }
        }).catch((error) => {
          this.isLoading = false;
          this.resetForm();
          const decryptedError = decrypt(error.response.data);
          const objError = JSON.parse(decryptedError);
          this.$swal({
            title: 'Oops...',
            text: objError.errors[0],
            type: 'error',
            confirmButtonText: 'Ok'
          });
        })
      },
      async searchFlight() {
        if(this.form.flightSearchType === 'Multidestination') {
          let check = true;
          this.flightForm.forEach((flight) => {
            if (flight.itineraries.departure === '' || flight.itineraries.destination === '') {
              this.$swal({
                title: 'Oops...',
                text: 'Kindly select your departure or destination',
                type: 'error',
                confirmButtonText: 'Ok',
              });
              check = false;
              return check;
            } else if (flight.itineraries.departureDate === '') {
              this.$swal({
                title: 'Oops...',
                text: 'Kindly select your departure Date',
                type: 'error',
                confirmButtonText: 'Ok',
              });
              check = false;
              return check;
            } else if(this.form.adults === 0 && this.form.children === 0 && this.form.infants === 0) {
              this.$swal({
                title: 'Oops...',
                text: 'Please select at least one passenger',
                type: 'error',
                confirmButtonText: 'Ok',
              });
              check = false;
              return check;
            } else if (this.flightForm.length <= 1) {
              this.$swal({
                title: 'Oops...',
                text: 'Kindly add more than one flight',
                type: 'error',
                confirmButtonText: 'Ok',
              });
              check = false;
              return check;
            }
          });
          if (check) {
            this.callSerachForMultiway();
          }
        } else if(this.form.flightSearchType === 'Oneway') {
          if(this.itineraries.departure === '' || this.itineraries.destination === '' || this.itineraries.destination === null || this.itineraries.departure === null) {
            this.$swal({
              title: 'Oops...',
              text: 'Please select destination and departure',
              type: 'error',
              confirmButtonText: 'Ok',
            });
            return;
          } if (this.itineraries.departureDate === '' || this.itineraries.departureDate === null) {
            this.$swal({
              title: 'Oops...',
              text: 'Please select departure date',
              type: 'error',
              confirmButtonText: 'Ok',
            });
            return;
          } if(this.form.adults === 0 && this.form.children === 0 && this.form.infants === 0) {
            this.$swal({
              title: 'Oops...',
              text: 'Please select at least one passenger',
              type: 'error',
              confirmButtonText: 'Ok',
            });
            return;
          } else {
            if(this.form.itineraries.length > 1) {
              this.form.itineraries.splice(0, this.form.itineraries.length - 1);
            }
            this.isLoading = true;
            this.$store.dispatch('flight/getListOfFlights', this.form).then(() => {
              this.$store.commit('flight/SET_ONE_WAY_DATE', this.itineraries.departureDate)
              this.$store.commit('flight/SET_FLIGHT_TYPE', this.form.flightSearchType)
              this.isLoading = false;
              if(this.listOfFlights.length > 0) {
                this.$router.push({ name: 'flight-search' });
              } else {
                this.$swal({
                  title: 'Oops...',
                  text: 'No flights found',
                  type: 'error',
                  confirmButtonText: 'Ok',
                });
              }
            }).catch((error) => {
              this.isLoading = false;
              this.resetForm();
              const decryptedError = decrypt(error.response.data);
              const objError = JSON.parse(decryptedError);
              this.$swal({
                title: 'Oops...',
                text: objError.errors[0],
                type: 'error',
                confirmButtonText: 'Ok'
              });
            })
          }
        } else {
          if(this.itineraries.departure === '' || this.itineraries.destination === '') {
            this.$swal({
              title: 'Oops...',
              text: 'Please select destination and departure',
              type: 'error',
              confirmButtonText: 'Ok',
            });
            return;
          } if (this.itineraries.departureDate === '' || this.itineraries.departureDate === null) {
            this.$swal({
              title: 'Oops...',
              text: 'Please select departure date',
              type: 'error',
              confirmButtonText: 'Ok',
            });
            return;
          } if(this.form.adults === 0 && this.form.children === 0 && this.form.infants === 0) {
            this.$swal({
              title: 'Oops...',
              text: 'Please select at least one passenger',
              type: 'error',
              confirmButtonText: 'Ok',
            });
            return;
          } else {
            this.form.itineraries.push({
              departure: this.itineraries.destination,
              destination: this.itineraries.departure,
              departureDate: moment(this.returnDepartureDate).format('YYYY-MM-DD'),
            });
            if(this.form.itineraries.length > 2) {
              this.form.itineraries.splice(0, this.form.itineraries.length - 2);
            }
            this.isLoading = true;
            this.$store.dispatch('flight/getListOfFlights', this.form).then(() => {
              this.$store.commit('flight/SET_ROUND_TRIP_DATE', this.returnDepartureDate)
              this.$store.commit('flight/SET_FLIGHT_TYPE', this.form.flightSearchType)
              this.isLoading = false;
              if(this.listOfFlights.length > 0) {
                this.$router.push({ name: 'flight-search' });
              } else {
                this.$swal({
                  title: 'Oops...',
                  text: 'No flights found',
                  type: 'error',
                  confirmButtonText: 'Ok',
                });
              }
            }).catch((error) => {
              this.isLoading = false;
              this.resetForm();
              const decryptedError = decrypt(error.response.data);
              const objError = JSON.parse(decryptedError);
              this.$swal({
                title: 'Oops...',
                text: objError.errors[0],
                type: 'error',
                confirmButtonText: 'Ok'
              });
            })
          }
        }
      },
      closeDateModal(type) {
        switch (type) {
          case 'multi-way':
          this.isDateOpen = false;
          this.setDateValue(this.dateIndex)
            break;
          case 'one-way':
          this.isDateOpen = false;
          this.form.itineraries.push({
            departure: this.itineraries.departure,
            destination: this.itineraries.destination,
            departureDate: moment(this.itineraries.departureDate).format('YYYY-MM-DD')
          })
          default:
            break;
        }
       ;
      },
      showDateModal() {
        this.isDateOpen = !this.isDateOpen;
        if(this.isFlightType) {
          this.isFlightType = false;
        }
        // this.dateValue = this.flightForm[this.dateIndex].itineraries.departureDate
      },
      openFlightDetails() {
        this.isFlightType = true;
        if(this.isDateOpen) {
          this.isDateOpen = false;
        }
      },
      closeFlightDetails() {
        this.isFlightType = false;
      },
      setFlightDetails() {
        const passengerTotal = this.form.adults + this.form.children + this.form.infants
        this.isFlightType = true;
        if(this.isDateOpen) {
          this.isDateOpen = false;
        }
        if(this.form.adults === 0 && this.form.children === 0 && this.form.infants === 0) {
          this.$swal({
            title: 'Oops...',
            text: 'Please select at least one passenger',
            type: 'error',
            confirmButtonText: 'Ok',
          });
          return;
        } else if (passengerTotal > 9) {
          this.$swal({
            title: 'Oops...',
            text: 'Total Number of passenger should not be more than 9',
            type: 'error',
            confirmButtonText: 'Ok',
          });
          return;
        } else {
          this.isFlightType = false;
        }
      },
      resetForm() {
        this.infantText = ''
        this.isDepatureDropdown = false
        this.isDestinationDropdown = false
        this.form.itineraries = [];
        this.returnDeparture = '';
        this.returnDestination = '';
        this.returnDepartureDate = '';
        this.itineraries = {
          departure: '',
          destination: '',
          departureDate: '',
          returnDate: '',
        };
        this.isLoading = false;
        this.searchDeparture = '';
        this.searchDestination = '';
        this.form.adults = 0;
        this.form.children = 0;
        this.form.infants = 0;
        this.form.ticketclass = 'Y';
        this.flightForm = [{
          flightSearchType: 'Return',
          ticketclass: 'Y',
          adults: 0,
          children: 0,
          infants: 0,
          targetCurrency: 'NGN',
          appPlatform: 1,
          itineraries: {
            departure: '',
            destination: '',
            departureDate: new Date(),
            returnDate: '',
          }
        }];
      }
    },
  };
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.page__header--text {
    position: relative;
    z-index: 999;
}
p {
    letter-spacing: 0;
}
.airport-wraper {
    width: 288px;
    height: 300px;
    background: white;
    overflow-y: scroll;
    position: absolute;
    left: 6.3rem;
    top: 10rem;
    padding: 0px 20px 20px 20px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
}
.airport-wraper-return {
    width: 288px;
    height: 300px;
    background: white;
    overflow-y: scroll;
    position: absolute;
    left: 6.2rem;
    top: 16.5rem;
    padding: 0px 20px 20px 20px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
}
.airport-wraper-destination {
    width: 288px;
    height: 300px;
    background: white;
    overflow-y: scroll;
    position: absolute;
    left:36.6%;
    top: 10rem;
    padding: 0px 20px 20px 20px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
}
.airport-wraper-destination-return {
    width: 288px;
    height: 300px;
    background: white;
    overflow-y: scroll;
    position: absolute;
    left:36.4%;
    top: 16.5rem;
    padding: 0px 20px 20px 20px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
}

.page-home {
    box-sizing: border-box;
    background:rgba(0, 0, 0, 0.5)url(../../../assets/TAJimages/flight/bg-flight.png);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    height: 100%;
    padding-bottom: 20rem;
}
.overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
}
.page__header {
    padding-top: 60px;
}
.page__header h5 {
    font-size: 21px;
    letter-spacing: 0px;
    color: #FFFFFF;
    font-weight: 300;
}
.page__header h4 {
    font-size: 23px;
    letter-spacing: 0px;
    color: #FFFFFF;
    font-weight: 500;
    opacity: 1;
    padding-top: 24px;
}
.search__section--wrapper {
    background-color: rgba(255, 255, 255, 0.3);
    border-radius: 10px;
    opacity: 1;
    backdrop-filter: blur(7px);
    -webkit-backdrop-filter: blur(7px);
    width: 100%;
    height: 100%;
    margin-top: 50px;
    padding: 40px 50px;
}
.flight-from {
    width: 290px;
    height: 100%;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: inset 0px 3px 6px #00000029;
    border: 1px solid #CCCCCC;
    border-radius: 10px;
    opacity: 1;
    cursor: pointer;
}
.flight-text h6 {
    font-size: 15px;
    margin-bottom: 0;
}
.flight-text h5 {
    font-size: 18px;
    margin-bottom: 0;
    font-weight: bold;
}
.flight-text p {
    font-size: 12px;
    margin-bottom: 0;
    font-weight: 100;
}
.flight-date {
    background: #242B38;
    box-shadow: inset 0px 3px 6px #00000029;
    border-radius: 10px;
    opacity: 1;
    color: #fff;
    width: 155px;
    height: 78px;
    font-size: 17px;
    font-weight: 500;
    cursor: pointer;
    z-index: -1;
}
.flight-type {
    margin-left: 8px;
    width: 145px;
    height: 78px;
    background: #242B38 0% 0%;
    box-shadow: inset 0px 3px 6px #00000029;
    border-radius: 10px;
    color: #fff;
    padding: 20px;
    cursor: pointer;
}
.flight-type-multi {
    height: 78px;
    background: #242B38 0% 0%;
    box-shadow: inset 0px 3px 6px #00000029;
    border-radius: 10px;
    color: #fff;
    padding: 20px;
    cursor: pointer;
    padding: 0 30px;
}
.text-cabin {
    font-size: 12px;
    font-weight: 500;
    margin-bottom: 5px;
    color: #697886;
}
.text-eco {
    font-size: 15px;
    font-weight: 500;
    margin-bottom: 5px;
    color: #fff;
}
.text-class {
    font-size: 13px;
    font-weight: 100;
    margin-bottom: 0;
    color: #fff;
}
.text-number {
    position: absolute;
    top: -5px;
    left: 105px;
}
.refresh {
    position: absolute;
    background: #232B38;
    padding: 8px;
    border-radius: 50%;
    left: 34%;
}
.multi-way {
    left: 43% !important;
}
.search-btn {
    height: 50px;
    max-width: 200px;
    width: 200px;
}
.flight-type-menu {
    position: absolute;
    right: 40px;
    top: 60%;
    width: 340px;
    /* height: 100%; */
    padding: 35px 20px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 30px #0000001A;
    border-radius: 10px;
    opacity: 1;
}
.select--menu label{
    text-align: left;
    font-size: 14px;
    letter-spacing: 0px;
    color: #232949;
    opacity: 1;
}
.pass-section {
    margin-top: 20px;
}
.pass-section h4 {
    text-align: center;
    font-size: 18px;
    letter-spacing: 0px;
    color: #232949;
    opacity: 1;
    margin-bottom: 30px;
}
.minus {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    background: #F0F0F0 0% 0% no-repeat padding-box;
    border-radius: 7px;
    opacity: 1;
    font-size: 17px;
    font-weight: 500;
    cursor: pointer;
}
.plus {
    color: #E41617;
    background: #FAE1DC;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border-radius: 7px;
    opacity: 1;
    font-size: 17px;
    font-weight: 500;
    cursor: pointer;
}
.pass-text h4 {
    font-size: 18px;
    letter-spacing: 0px;
    color: #020202;
    margin-bottom: 5px;
}
.pass-text p {
    font-size: 13px;
    letter-spacing: 0px;
    color: #9B9AAC;
    margin-bottom: 0;
    font-weight: 100;
}
div >>> .vs__dropdown-toggle {
    width: 200px !important;
    max-width: 200px !important;
    border: 0 !important;
}
.button__section {
    position: relative;
}
.date-wrapper {
    background: #fff;
    padding: 20px;
    z-index: 999;
    width: 580px;
    max-width: 100%;
    position: absolute;
    top: 55%;
    right: 23%;
}
.btn-custom {
    background: #FFF4F2;
    color: #E41617;
    border-radius: 7px;
    font-weight: 500;
    font-size: 17px;
    width: 150px;
}
.search-form {
    padding: 10px 10px 10px 9px;
    width: 200px;
    border: 0;
    font-size: 17px;
}
.search-form::placeholder {
    color: #020202 !important;
}
.multiselect >>> .multiselect__tags {
  width: 220px !important;
  border: none !important;
  margin-left: -12px !important;
}
.multiselect >>> .multiselect__content-wrapper {
  width: 290px !important;
  margin-left: -64px !important;
}
div >>> .vs__selected {
  font-size: 12.5px !important;
  width: 170px !important;
}
.multiselect >>> .multiselect__placeholder {
  color: #000 !important;
  font-size: 16px !important;
}
.flight-form-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
@media screen and (max-width: 768px) {
  .flight-form-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 0px !important;
  }
  .refresh {
    position: absolute;
    top: 35.5%;
    left: 45%;
  }
  .flight-from {
    width: 100%;
    margin-top: 30px;
    margin-left: 0px !important;
  }
  .date-wrapper {
    background: #fff;
    width: 100%;
    max-width: 100%;
    position: absolute;
    top: 55%;
    right: 0%;
  }
  .flight-type-menu {
    position: absolute;
    right: 0;
    top: 60%;
    width: 100%;
  }
  .m-h-4 {
    margin-top: 20px;
  }
  .airport-wraper {
    width: 281px;
    left: 13%;
    top: 13.5rem;
    z-index: 99;
  }
  .airport-wraper-destination {
    width: 281px;
    left: 13%;
    top: 20rem;
    z-index: 99;
  }
} 
</style>